import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage,
  ogType = "website",
  noIndex = false,
}) => {
  const location = useLocation();
  const siteName = "RNB Consulting Group";
  const siteUrl = "https://www.rnbconsultinggroup.com";
  const defaultDescription = "Boutique healthcare consulting for clinics, private practices, and healthcare startups. Clinic operations, staff productivity, EHR implementation, compliance readiness, and sustainable growth.";
  const defaultOgImage = "https://customer-assets.emergentagent.com/job_e6aa7c2c-d03d-4974-9cb2-630ed0a0b376/artifacts/e7qtpwyy_Bazaart_2CA00B66-0594-4702-AC94-D9D6D5BB8442%20(1).JPEG";
  
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Boutique Healthcare Consulting`;
  const metaDescription = description || defaultDescription;
  const pageUrl = `${siteUrl}${location.pathname}`;
  const imageUrl = ogImage || defaultOgImage;
  
  useEffect(() => {
    document.title = fullTitle;
    
    const updateMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    
    updateMeta('meta[name="description"]', "content", metaDescription);
    updateMeta('meta[property="og:title"]', "content", fullTitle);
    updateMeta('meta[property="og:description"]', "content", metaDescription);
    updateMeta('meta[property="og:url"]', "content", pageUrl);
    updateMeta('meta[property="og:image"]', "content", imageUrl);
    updateMeta('meta[name="twitter:title"]', "content", fullTitle);
    updateMeta('meta[name="twitter:description"]', "content", metaDescription);
    updateMeta('meta[name="twitter:url"]', "content", pageUrl);
    updateMeta('meta[name="twitter:image"]', "content", imageUrl);
  }, [fullTitle, metaDescription, pageUrl, imageUrl]);
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl || pageUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="author" content="RNB Consulting Group" />
      <meta name="geo.region" content="US-GA" />
      <meta name="geo.placename" content="Atlanta" />
    </Helmet>
  );
};

export default SEO;
